import { Routes, Route } from "react-router-dom";
import AppInfo from "./AppInfo";
import Privacy from "./Privacy";
import Support from "./Support";

// Arbol de rutas totalmente aislado de AppWrapper: no depende de sesion,
// token, ni de ningun servicio autenticado. Pensado para que la tienda
// (Apple/Google) y cualquier visitante sin login puedan verlo siempre.
export default function LegalPages() {
  return (
    <Routes>
      <Route index element={<AppInfo />} />
      <Route path="privacidad" element={<Privacy />} />
      <Route path="soporte" element={<Support />} />
    </Routes>
  );
}
